/**
 * Calculates the duration of the slideshow or a portion of it
 *
 * @param {Array} [slideshowSlides] The slides array
 * @param {Number} [defaultDuration] The slideshow's default MS duration
 * @param {Number} [stopIndex] The stop index, given we want the time up to a certain slide
 */
export const calculateSlideshowDuration = (
  slideshowSlides,
  defaultDuration,
  stopIndex = null,
) => {
  if (!slideshowSlides) {
    return 0;
  }

  if (stopIndex === -1) {
    return 0;
  }

  if (stopIndex !== null) {
    return slideshowSlides
      .slice(0, stopIndex)
      .reduce(sum => sum + defaultDuration, 0);
  }

  return slideshowSlides.reduce(sum => sum + defaultDuration, 0);
};
